var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8288 8.91222C13.9381 8.80282 13.9995 8.65448 13.9995 8.4998C13.9995 8.34512 13.9381 8.19677 13.8288 8.08738L8.28708 2.54571C8.17769 2.43636 8.02935 2.37492 7.87467 2.37492C7.71999 2.37492 7.57164 2.43636 7.46225 2.54571L4.958 5.04997L0.995418 1.08738C0.8854 0.981123 0.738049 0.922326 0.5851 0.923655C0.432152 0.924984 0.285845 0.986333 0.17769 1.09449C0.0695356 1.20264 0.00818707 1.34895 0.00685799 1.5019C0.00552891 1.65485 0.0643256 1.8022 0.170585 1.91222L4.54558 6.28722C4.65498 6.39657 4.80332 6.45801 4.958 6.45801C5.11268 6.45801 5.26103 6.39657 5.37042 6.28722L7.87467 3.78297L13.0039 8.91222C13.1133 9.02157 13.2617 9.08301 13.4163 9.08301C13.571 9.08301 13.7194 9.02157 13.8288 8.91222Z",
    fill: "#E00000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33105 8.49967C9.33105 8.65438 9.39251 8.80276 9.50191 8.91215C9.6113 9.02155 9.75968 9.08301 9.91439 9.08301H13.4144C13.5691 9.08301 13.7175 9.02155 13.8269 8.91215C13.9363 8.80276 13.9977 8.65438 13.9977 8.49967V4.99967C13.9977 4.84496 13.9363 4.69659 13.8269 4.5872C13.7175 4.4778 13.5691 4.41634 13.4144 4.41634C13.2597 4.41634 13.1113 4.4778 13.0019 4.5872C12.8925 4.69659 12.8311 4.84496 12.8311 4.99967V7.91634H9.91439C9.75968 7.91634 9.6113 7.9778 9.50191 8.0872C9.39251 8.19659 9.33105 8.34496 9.33105 8.49967Z",
    fill: "#E00000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/downIcon.e675a11548f2fbe5747bc1035624a925.svg";
export { ForwardRef as ReactComponent };